import { useEffect, useState } from 'react'
import type { ApolloClient } from '@apollo/client'
import type { User, BookShelf } from 'api/data.types'
import { getCollections as getCollectionsQuery } from 'api/queries/reader'
import type { Module } from 'api/data.types'
import { allBookshelvesQuery } from 'api/queries'

const useBookCollection = (
  client: Pick<ApolloClient<object>, 'query'>,
  contentFilter: Module,
  isStudentView,
  degree,
  title
) => {
  const [content, setContent] = useState<BookShelf[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    setIsLoading(true)
    isStudentView ? getCollectionsAsStudent() : getCollections()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [degree])

  const getCollections = () => {
    client
      .query<{
        me: User
      }>({
        query: getCollectionsQuery,
        variables: {
          contentFilter
        }
      })
      .then(res => {
        const { collections } = res.data.me.reader
        setCollections({ collections })
      })
      .catch(err => console.log(`Oops, aconteceu um erro: ${err.message}`))
  }

  const getCollectionsAsStudent = () => {
    client
      .query<{
        listExistingBookshelf: BookShelf[]
      }>({
        query: allBookshelvesQuery,
        variables: {
          contentFilter,
          degreeRange: degree,
          isHighlight: false,
          acervoType: null,
          type: 'collection',
          active: true
        }
      })
      .then(res => {
        const { listExistingBookshelf } = res.data
        setCollections({ collections: listExistingBookshelf })
      })
      .catch(err => console.log(`Oops, aconteceu um erro: ${err.message}`))
  }

  const setCollections = ({ collections }) => {
    setContent(collections)
    setIsLoading(false)
  }

  return { content, isLoading }
}

export { useBookCollection }
